import React from 'react';
import ButtonBase from './ButtonBase';
import Asset from '../Asset';
import Box from '../Box/Box';
import { Brand, TButtonThirdParty } from './types/TButtons';
import getClassNames from '../../utils/className/getClassNames';
import { TAsset } from 'types/TStyleVariables';

const buttonAssets: Record<Brand, { assetName: TAsset; isInline?: boolean; isBackgroundFilled?: boolean }> = {
  google: { assetName: 'social-badge-google', isBackgroundFilled: true },
  apple: { assetName: 'social-badge-apple' },
  bancontact: { assetName: 'icon-logo-bancontact', isBackgroundFilled: true },
  ideal: { assetName: 'logo-ideal-wero-horizontal-inverse', isInline: true },
};

const ThirdParty = ({ as = 'button', brand, children, ...rest }: TButtonThirdParty) => {
  const brandAsset = buttonAssets[brand];
  if (!brandAsset) {
    // eslint-disable-next-line no-console
    console.warn(`Unsupported brand: ${brand}`);
    return null;
  }
  const { assetName, isBackgroundFilled, isInline } = brandAsset;
  return (
    <ButtonBase
      {...rest}
      as={as}
      kind="thirdParty"
      additionalModifiers={[brand, isInline && 'thirdParty-inlineVariant']}
    >
      {!isInline && (
        <Box as="span" name="ThirdPartyButtonAssetContainer" modifiers={isBackgroundFilled ? ['with-background'] : []}>
          <Asset.Square name={assetName} size="m" inverse={true} />
        </Box>
      )}

      <Box as="span" name="ThirdPartyButtonTextContainer">
        {children}
      </Box>
      {isInline && <Asset.Fluid name={assetName} className={getClassNames({ name: 'ThirdPartyButtonInlineAsset' })} />}
    </ButtonBase>
  );
};

export default ThirdParty;
